module.exports = __webpack_public_path__ + "media/images/favicon-6bcf5aaaa88505f3184b8ccfacc01b2f.png";